(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator.js');
"use strict";


const {
  useState
} = React;
const mockableImports = {
  Button: svs.ui.ReactButton
};
const MAX_AMOUNT_OF_VISIBLE_STEPS = 6;

const StepIndicator = props => {
  const {
    branding,
    daysPerStep,
    handleClickByIndex,
    steps,
    numberOfActiveSteps,
    isInvertedButtons
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(undefined);
  const itemSpacerClasses = ['competition-step-indicator-item-spacer'];
  if (isInvertedButtons) {
    itemSpacerClasses.push('inverted');
  }
  let prevDate = null;
  let stepLabels;
  if (steps) {
    stepLabels = steps.map(item => {
      if (item.date) {
        prevDate = new Date(item.date);
      } else if (prevDate) {
        prevDate = new Date(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate() + daysPerStep);
      }
      if (item.label) {
        return item.label;
      }
      if (prevDate instanceof Date) {
        return "".concat(prevDate.getDate(), "/").concat(prevDate.getMonth() + 1);
      }
      return '';
    });
  }
  return React.createElement("div", {
    className: "competition-step-indicator"
  }, stepLabels.slice(0, MAX_AMOUNT_OF_VISIBLE_STEPS).map((label, index) =>
  React.createElement(React.Fragment, {
    key: "".concat(label, "_").concat(index)
  }, index === 0 ? null : React.createElement("div", {
    className: itemSpacerClasses.join(' ')
  }), React.createElement(StepIndicatorItem, {
    branding: branding,
    buttonText: label,
    handleClick: handleClickByIndex,
    index: index,
    isActive: index < numberOfActiveSteps,
    isInvertedButtons: isInvertedButtons,
    selectedIndex: selectedIndex,
    setSelectedIndex: setSelectedIndex
  }))));
};
const getButtonSetup = (isInvertedButtons, isActive, isSelected) => {
  if (isInvertedButtons) {
    return {
      inverted: !isSelected,
      transparent: !isSelected
    };
  }
  return {
    inverted: isSelected && isActive,
    transparent: !isSelected || !isActive
  };
};
const StepIndicatorItem = props => {
  const {
    branding,
    isActive,
    buttonText,
    index,
    handleClick,
    selectedIndex,
    setSelectedIndex,
    isInvertedButtons
  } = props;
  const {
    Button
  } = mockableImports;
  const isSelected = selectedIndex === index;
  const buttonSettings = getButtonSetup(isInvertedButtons, isActive, isSelected);
  const buttonClasses = ['qa-competition-step-indicator-item-button competition-step-indicator-item-button'];
  if (isActive) {
    buttonClasses.push('competition-step-indicator-item-button-active');
  }
  if (isSelected) {
    buttonClasses.push('competition-step-indicator-item-button-selected');
  }
  if (branding) {
    buttonClasses.push("competition-step-indicator-item-button-".concat(branding));
  }
  return React.createElement("div", {
    className: "competition-step-indicator-item"
  }, React.createElement(Button, {
    block: true,
    className: buttonClasses.join(' '),
    disabled: !isActive,
    inverted: buttonSettings.inverted,
    onClick: typeof handleClick === 'function' ? () => {
      const selected = index === selectedIndex ? undefined : index;
      setSelectedIndex(selected);
      handleClick(index);
    } : null,
    transparent: buttonSettings.transparent
  }, buttonText));
};
StepIndicator.defaultProps = {
  daysPerStep: 7,
  handleClickByIndex: null
};
StepIndicator._testInternals = {
  getMockableImports: () => mockableImports
};
setGlobal('svs.components.marketplaceShared.stepIndicator.StepIndicator', StepIndicator);

 })(window);